import defaultAttributes from '../defaultAttributes';

const Forward = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '15 17 20 12 15 7' }],
    ['path', { d: 'M4 18v-2a4 4 0 014-4h12' }],
  ],
];

export default Forward;
